import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation11 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };
    return (

        <>
        



        <div className="container mt-1 p-3 mb-1" >


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                      Certificate Course in CorelDRAW (DTP)

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%"}}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in CorelDRAW (DTP)
                </h5>
                <p>
                    The HKCL DTP (CorelDRAW) 120 hours course is designed to equip learners with the essential skills needed for effective desktop publishing using industry-standard tools like Adobe and CorelDRAW. This comprehensive 120-hour program delves into the intricacies of design, layout, and graphics manipulation, providing a solid foundation for aspiring graphic designers and desktop publishers.</p>


            </div>
            <hr />


            <h5 style={{ position: "relative" }}>
                What does Graphic Designer Do?
            </h5>
            <p>This 120-hour course is structured to provide a balance between theoretical knowledge and practical application, making it suitable for beginners and those looking to enhance their existing skills in desktop publishing. Learners of the DTP program emerge with a comprehensive skill set, ready to make a meaningful impact in the dynamic field of graphic design and desktop publishing.</p>
            <hr />

            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>

            <p>A graphic designer can work with companies/enterprises working in print, web, multimedia, eLearning and gaming industry.</p>
            <p>Bachelor’s Degree/ Diploma in graphic design or a related field is usually required for jobs in this field. Candidates should demonstrate their creativity and originality through a professional portfolio that features their best designs. He/She can do a job or can work as a freelance designer. A fresher can draw up to Rs. 100,000/- p.a.</p>
            <hr></hr>

            <h5 style={{ position: "relative" }}>

                Course Highlights:
            </h5>
            <ul>

                <li> Introduction to Desktop Publishing: Learners will gain a fundamental understanding of the principles and practices of desktop publishing, exploring its role in creating visually appealing documents.</li>
                <li> CorelDRAW Mastery: Learners will delve into the versatile features of CorelDRAW, honing their skills in vector illustration and page layout to create stunning designs.</li>
                <li> Typography and Layout Design: The program emphasizes the importance of effective typography and layout design, guiding learners in creating visually appealing and readable documents.</li>
                <li> Print Production Techniques: Learners will learn about the intricacies of print production, including colour management, resolution, and preparing files for print.</li>
                <li> Project Work: Practical application is a key component of the course, with hands- on projects allowing learners to apply their skills in real-world scenarios.</li>
                <li> Industry-Relevant Skills: The curriculum is tailored to meet industry demands, ensuring that learners are well-prepared for careers in graphic design, advertising, and print media.</li>


            </ul>
            <hr />



            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> CorelDRAW (DTP) course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>

            </div>
            <hr />
            
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                  
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
                <hr />
            </div>

            <h5>Syllabus</h5>

            <div className='p-4' >



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Introduction to DTP</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li> Purpose of Learning DTP</li>
                                <li> Getting introduced to the DTP Course</li>
                                <li> Understanding what Desktop Publishing is</li>
                                <li> Knowing where DTP is used.</li>
                                <li> Understanding who uses DTP.</li>
                                <li> DTP in marketing: importance and usage</li>
                                <li> Learning DTP formats and outputs</li>
                                <li> Taking real-life examples of DTP</li>
                                <li> Understanding print and online in DTP</li>
                                <li> Learning about tools for DTP</li>
                                <li> Working with images</li>
                                <li> How to choose images</li>
                                <li> Understanding and using the image Resources</li>
                                <li> What are copyrights?</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">CorelDRAW</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li> Learning the basics of CorelDRAW</li>
                                <li> Understanding what CorelDRAW is</li>
                                <li> Exploring the CorelDRAW user interface</li>
                                <li> Understanding the Basics in CorelDRAW</li>
                                <li> Getting to learn more about CorelDRAW.</li>
                                <li> Working with the Page Set-Up</li>
                                <li> Working with files and documents</li>
                                <li> Getting Started with CorelDRAW</li>
                                <li> Knowing and using the basic controls</li>
                                <li> Understanding the Color Palette</li>
                                <li> Understanding the Viewing Options</li>
                                <li> Understanding the psychology of colors</li>
                                <li> Exploring the Color Palette in CorelDRAW</li>
                                <li> Understanding what Harmonious colors are</li>
                                <li> Working with colors</li>
                                <li> Working with the Color Palette</li>
                                <li> Exploring the use of various color fills</li>
                                <li> Working with Objects in CorelDRAW</li>
                                <li> Working with other Fill tools</li>
                                <li> Manipulating the objects</li>
                                <li> Working with Objects in CorelDRAW</li>
                                <li> Inserting and formatting text</li>
                                <li> Case Study: Letterhead with Logo</li>
                                <li> Learning to design a Letterhead with Logo</li>
                                <li> Working with Objects in CorelDRAW</li>
                                <li> Settings for Typing in Shree-Lipi</li>
                                <li> Case Study: Visiting Card</li>
                                <li> Creating a Visiting Card in CorelDraw</li>
                                <li> Formatting the Visiting Card in CorelDraw</li>
                                <li> CorelDRAW controls and features: Understanding</li>
                                <li> Working with Layers</li>
                                <li> Case Study: Sticker</li>
                                <li> Designing a Sticker in CorelDRAW</li>
                                <li> Getting to know other controls and features in CorelDRAW.</li>
                                <li> Working with Tables</li>
                                <li> Case Study: Flex Banner</li>
                                <li> Creating a Flex Banner in CorelDraw</li>
                                <li> Modifying the Flex Banner design</li>
                                <li> Case Study: Wedding Card</li>
                                <li> Designing a Wedding Card in CorelDRAW</li>
                                <li> Wedding Card design: Completing and exporting.</li>
                                <li> Case Study: Flyer with Coupon</li>
                                <li> Designing a Flyer with Coupon</li>
                                <li>Completing the design of Flyer with Coupon</li>
                                <li> Learning about the other features</li>
                                <li> Studying about Bitmaps</li>
                                <li> Going 3D</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Starting a Client based Project</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li>Meeting the client</li>
                                <li>Client Brief</li>
                                <li>Content and Graphics</li>
                                <li> Marketing Plan</li>
                                <li>Look n feel.</li>
                                <li>How to start designing an output</li>
                                <li>What are primary sketches?</li>
                                <li>The process of designing an output</li>
                                <li>What is a Moodboard?</li>
                                <li>Outcome</li>
                                <li>Printing and scanning basics: Understanding.</li>
                                <li>Listing various types of printers</li>
                                <li>Printers based on technology: Learning.</li>
                                <li>Printers based on characteristics: Learning.</li>
                                <li>Learning about the different printer qualities</li>
                                <li>Case Study: Brochure</li>
                                <li>Learning about shapes and designing a Brochure</li>
                                <li> Designing Shapes, Completing Brochure design</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Printing Concepts</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li>Learning about the printing concepts</li>
                                <li> Learning about the printing terms</li>
                                <li>Case Study: Product Box Package</li>
                                <li>Creating a nice Product Box Package design</li>
                                <li>Formatting, exporting Product Box design.</li>
                                <li> Learning about the printing concepts</li>
                                <li> Understanding DPI & Resolution</li>
                                <li> Defining the printing fonts</li>
                                <li> Identifying the ideal file formats</li>
                                <li> Learning about the printing technologies</li>
                                <li> Identifying various printing methods</li>
                                <li> Learning about the printing technologies</li>
                                <li> Studying Digital Printing vs. Offset Printing</li>
                                <li> Defining the types of printer papers</li>
                                <li> Types of printer papers: Understanding</li>
                                <li> Suitable papers for printer types: Understanding</li>
                                <li> Attributes of printer papers: Learning</li>
                                <li>Post Press – Print Project Finishing</li>
                                <li> Completing a Print Project</li>
                                <li> Case Study: Book Cover</li>
                                <li> Creating, designing Book Cover in new document</li>
                                <li> Finishing Book Cover design</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Introduction to new version of CorelDRAW</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li>Introduction to CorelDRAW</li>
                                <li>Introduction to new version of CorelDRAW</li>
                                <li>Choosing a workspace in CorelDRAW</li>
                                <li>CorelDRAW default workspace: Understanding and use.</li>
                                <li>Case Study: Newspaper advertising</li>
                                <li>Designing an advertisement in CorelDRAW</li>
                                <li>Enhancing and completing the Newspaper advertising</li>
                                <li>Introduction to CorelDRAW</li>
                                <li>Customizing Toolbars</li>
                                <li> Customizing the Property Bar</li>
                                <li>Corel Font Manager</li>
                                <li>Customizing Workspace Appearance</li>
                                <li> Getting to know the new CorelDRAW.</li>
                                <li>Design anything easily using CorelDRAW.</li>
                                <li>Suitable platforms for using CorelDRAW.</li>
                                <li>Design graphics with purpose.</li>
                                <li>Bring out your creativity.</li>
                                <li>Other enabling tools</li>
                                <li> Exploring the new features of CorelDRAW</li>
                                <li>Using CorelDRAW smartly for impressive work</li>
                                <li>Using the shortcut keys for smart work</li>
                                <li>Case Study- Hoarding Design</li>
                                <li> Objective</li>
                                <li> Designing Hoarding in new CorelDRAW document</li>
                                <li>Enhancing the Hoarding design</li>
                                <li>Summary</li>
                                <li>Outcome</li>
                                <li> Exploring new features</li>
                                <li> Enable powerful machine learning.</li>
                                <li> Using cutting-edge typography</li>
                                <li>Some user-inspired enhancements</li>
                                <li>Putting these features into practice</li>
                                <li> Career opportunities</li>
                                <li>Designing field: Various job opportunities</li>
                                <li>Requirements to start your designing career.</li>
                                <li>Introduction to building blocks of publication</li>
                                <li>Role of CorelDRAW in Print Media</li>
                                <li>Combine Case Study Adobe Photoshop-CorelDRAW</li>
                                <li>Case Study - Brochure</li>
                                <li>Objective</li>
                                <li>Designing Tri-fold Brochure in Adobe Photoshop</li>
                                <li>Modifying Tri-fold Design in CorelDRAW</li>
                                <li> Summary</li>
                                <li> Case Study-Magazine Cover and Back</li>
                                <li> Objective</li>
                                <li> Creating Magazine Cover and Back Page: Beginning</li>
                                <li> Enhancing, exporting Magazine Cover design</li>
                                <li> Summary</li>
                                <li> Case Study-e-Book</li>
                                <li> Objective</li>
                                <li> Creating an e-Book in Inkscape</li>
                                <li> Formatting and completing the e-Book design.</li>
                                <li> Summary</li>
                                <li> Case Study-Business Proposal</li>
                                <li> Objective</li>
                                <li> Creating a Business Proposal in CorelDRAW</li>
                                <li> Modifying, finishing Business Proposal</li>
                                <li> Summary</li>
                                <li> Understanding the objective behind merging data</li>
                                <li> CSV file and its role in data merging: Understanding</li>
                                <li> CorelDRAW for data merging: Understanding utility.</li>
                                <li> Data Merging from a Microsoft Excel document</li>
                                <li> Data Merging from a Microsoft Word file</li>
                                <li> Data Merging from a PDF file</li>
                                <li> Getting started with Adobe Illustrator</li>
                                <li> Learning the basics of Adobe Illustrator</li>
                                <li> Getting introduced to Adobe Illustrator</li>
                                <li> Learning about colors in Illustrator</li>
                                <li> Basic tools of Illustrator: Introduction</li>
                                <li> The Working Place</li>
                                <li> Getting to know the user interface.</li>
                                <li> Customizing the designs</li>
                                <li> Organizing files</li>
                                <li> Saving files</li>
                                <li>Understanding Artboards</li>
                                <li> Tools</li>
                                <li> Learning about the Selection tools</li>
                                <li> Drawing and painting tools: Introduction</li>
                                <li> Efficient use of drawing, painting tools</li>
                                <li> Tools</li>
                                <li> Mastering the use of artistic tools</li>
                                <li> Using artistic tools</li>
                                <li> Learning best way to use artistic tools.</li>
                                <li> Learning more tools for drawing, painting</li>
                                <li> Using the painting and drawing tools</li>
                                <li> Tools</li>
                                <li> Mastering artistic tools and more</li>
                                <li> Using new drawing and painting tools</li>
                                <li> Discovering the Type tool</li>
                                <li> Using the Zoom and Moving tools</li>
                                <li> Introduction to Layers and its options</li>
                                <li>Layers, options for better organization</li>
                                <li> Case Study- Business Card</li>
                                <li> Creating a Business Card</li>
                                <li> Using Pen, Pencils, and Paths</li>
                                <li> Paths and options: Learning more</li>
                                <li> Using the Brush and Paint</li>
                                <li> Exploring the Brushes</li>
                                <li> Exploring the Brush Library</li>
                                <li> Painting in Illustrator</li>
                                <li> Blending in Adobe Illustrator</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="12">Envato</AccordionHeader>
                        <AccordionBody accordionId="12">
                            <ul>
                                <li> Envato</li>
                                <li>Learning what Envato is</li>
                                <li> Understanding the use of Envato</li>
                                <li> Getting the overview of user interface</li>
                                <li> Learning the smart tips for working</li>
                                <li> Outcome</li>
                                <li> Recalling key factors of ready-to-use templates</li>
                                <li> Discovering the major factors about templates</li>
                                <li> Exploring when to and how to use templates.</li>
                                <li>Efficient Designing within Deadlines</li>
                                <li> Identifying templates for various mediums</li>
                                <li> Identifying software using templates for work</li>
                                <li> Understanding how templates can ease and speed up your work.</li>
                                <li> Outcome</li>
                                <li> Learning Presenter Media and template use</li>
                                <li> What is PresenterMedia and its use?</li>
                                <li> Alternatives to PresenterMedia?</li>
                                <li> Use of Templates in PresenterMedia</li>
                                <li> Use of Templates in other websites</li>
                                <li> Interface Overview of PresenterMedia</li>
                                <li> Smarter tips for PresenterMedia, other sites</li>
                                <li> Outcome</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">Canva</AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li>What is Canva and what are its uses?</li>
                                <li> What are free Templates in Canva?</li>
                                <li> Essential Elements in Canva</li>
                                <li> Interface Overview of Canva</li>
                                <li>Smart tips to work in with Canva</li>
                                <li>Combine Case Study Adobe Illustrator – Scribus</li>
                                <li>Case Study-Product Manual</li>
                                <li>Objective</li>
                                <li>Product Manual: Understanding and Designing</li>
                                <li>Customizing and finalizing the Product Manual</li>
                                <li>Summary</li>
                                <li>Outcome</li>
                                <li>Case Study- Story Board</li>
                                <li>Objective</li>
                                <li>Beginning to design a storyboard.</li>
                                <li>Designing screens in storyboard with page setups</li>
                                <li>Summary</li>
                                <li>Outcome</li>
                                <li>Copyright</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>



            </div >
            <hr />
            <h5>CorelDraw</h5>
            <p><b>Skills:</b> Understanding the Color Palette, Working with the Objects, Understanding other controls (Layers and Tables)</p>
            <p><b>Outputs:</b> Newspaper Advertisement, Product packaging and display, LED Signage Design, Hoarding Design, Brochure, Annual Report, ID cards creation using Data Merge, Certificate, Flex Banner

            </p>
            <hr />

            <h5>Adobe Photoshop</h5>
            <p><b>Skills:</b> Working Place, Customizing, Image and Color Modifications, Case Study - Black & White to Color, Using the Brush and Paint, Working with Selections, Scaling, Knowing the Layers, Filter Gallery, Color Adjustments</p>
            <p><b>Outputs:</b> Web Layout Design, Web Banner, Advertisement, UI Design
            </p>
            <hr />

            <h5>Adobe InDesign</h5>
            <p><b>Skills:</b>Creating and Viewing a Document, Managing Pages and Books, Managing Text , Formatting , Working with Objects, Working with Points and Paths, Case Study- Book Cover, Applying and Managing Colors, Working with Tables, Working with Styles, Printing and Outputting a Document, Setting Preferences</p>
            <p><b>Outputs:</b>Story books, Wall Calendar, Newsletter, Maps, Menu Card, Magazine Cover Page, Recipe Book, Book Cover
            </p>
            <hr />

            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation11;